import { QueryOptions } from '@data/queries/types'
import { UseQueryResult } from '@tanstack/react-query'

export const ExperimentQueryKeyName = 'experiment'

export type ExperimentQueryKey = [
    typeof ExperimentQueryKeyName,
    {
        experimentName: TExperimentName
    },
]

export const ExperimentParticipationQueryKeyName = 'experiment-participation'

export type ExperimentParticipationQueryKey = [
    typeof ExperimentParticipationQueryKeyName,
    {
        experimentName: TExperimentName
    },
]

export type ExperimentQueryOptions<QueryKey extends ExperimentQueryKey | ExperimentParticipationQueryKey> =
    QueryOptions<TExperimentMap, ApiError, TExperimentMap, QueryKey>

type ImportantSegments = 'A' | 'B' | 'C' | 'D'

// Specifies that a given segment is either true or false
type IsSegment<Segment extends ImportantSegments, Value extends boolean> = { [key in `isSegment${Segment}`]: Value }

// Ensure that we have exactly one true segment and the rest of the segments are false
type Segment<Segment extends ImportantSegments> = IsSegment<Segment, true> &
    IsSegment<Exclude<ImportantSegments, Segment>, false>

export type SegmentValues =
    | Segment<'A'>
    | Segment<'B'>
    | Segment<'C'>
    | Segment<'D'>
    | { [key in `isSegment${ImportantSegments}`]: false }

type ExperimentInfo = {
    segment: TExperimentSegment
} & SegmentValues

export type QueryResultWithSegment = UseQueryResult<TExperimentMap, ApiError> & ExperimentInfo
